import { signed } from "./srUtil";

const ROWS = {
  any13f: ["Any fund bought beforehand", "the classic copy-the-filings setup"],
  crowded: ["Our funds’ picks, but crowded", "6 or more funds bought"],
  select: ["The select list", "all 3 conditions met"],
};

const hereKey = (w) => {
  const [f, c, l, s] = w.conditions;
  if (w.state === "select" || w.state === "pending") return "select";
  if (!s.met) return null;
  if (f.met) return !c.met && l.met ? "crowded" : null;
  return c.n >= 1 ? "any13f" : null;
};

const Bar = ({ b, max, here, symbol, pending }) => {
  const sel = b.key === "select", w = (Math.max(b.mean_pct, 0) / max) * 100;
  return (
    <div className={`ladrow${sel ? " sel" : ""}${here ? " here" : ""}`} data-testid={`sr-ladder-${b.key}`}>
      <div className="ladlabel"><b>{ROWS[b.key][0]}</b><small>{ROWS[b.key][1]}</small>
        {here && <span className="ladhere" data-testid="sr-ladder-here">{pending ? `${symbol} could be here` : `${symbol} is here`}</span>}</div>
      <div className="ladtrack">
        <span className="ladbar" style={{ width: `${Math.max(w, 0.8)}%` }} />
      </div>
      <div className="ladval"><b className={sel ? "green" : ""} data-testid={`sr-ladder-${b.key}-value`}>{signed(b.mean_pct, 2)}%</b>
        <small>beat {Math.round(b.hit_pct)}%</small></div>
    </div>
  );
};

export const EdgeLadder = ({ w, symbol }) => {
  const lad = w.ladder;
  if (!lad) return null;
  const max = Math.max(...lad.bars.map((b) => b.mean_pct), 0.1), here = hereKey(w);
  return (
    <div className="ladder" data-testid="sr-edge-ladder">
      <span className="eyebrow">Where the edge comes from</span>
      <p className="muted">Average results-day move vs industry, after costs, {lad.from}–{lad.to} · beat = how often it did better</p>
      <div className="ladrows">
        {lad.bars.map((b) => <Bar key={b.key} b={b} max={max} here={b.key === here} symbol={symbol} pending={w.state === "pending"} />)}
      </div>
    </div>
  );
};
